import mixpanel, { Dict } from 'mixpanel-browser';

const PROD_MIXPANEL_API_KEY = '1cb9ed1d914678aee9ae80c82c00e9e7';

export interface MixpanelClient {
    track: typeof mixpanel.track;
    register: (props: Dict) => void;
    identify: (uniqueId: string) => void;
    people: {
        set: (props: Dict) => void;
    };
}

function createNoOpClient(): MixpanelClient {
    return {
        track: (() => {}) as any,
        register: (_props: Dict) => {},
        identify: (_uniqueId: string) => {},
        people: {
            set: (_props: Dict) => {},
        },
    };
}

function isLocalEnvironment(): boolean {
    return typeof window !== 'undefined' && window?.location?.hostname === 'localhost';
}

export function initializeMixpanel(): MixpanelClient {
    if (isLocalEnvironment()) {
        return createNoOpClient();
    }

    try {
        // Mixpanel may be blocked in certain regions (China, corporate firewalls, VPNs)
        // Initialize with error handling to gracefully degrade if unavailable
        mixpanel.init(PROD_MIXPANEL_API_KEY, { debug: true });
        mixpanel.register({});
        return mixpanel;
    } catch (error) {
        console.warn('Mixpanel initialization failed (likely blocked in this region):', error);
        return createNoOpClient();
    }
}
